import React, { useEffect, useState } from "react";
import HeaderLogo from "../../components/header/headerLogo";
import "../../assets/scss/account/register.scss";
import { useHistory, Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Repository from "../../configs/axios/repository";
import Spinner from "../../@core/components/spinner/Fallback-spinner";
import googlePng from "../../assets/images/account/google.png";
import marketingJpg from "../../assets/images/account/login.svg";
import view from "../../assets/images/account/veiw.png";
import hidenIcon from "../../assets/images/account/hideIcon.png";
import clear from "../../assets/images/account/clear.png";
import jwt_decode from "jwt-decode";
import { Row, Col } from "reactstrap";
import "react-phone-number-input/style.css";
import Select from "react-select";
import PhoneInput from "react-phone-number-input";
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let lead_source = null;
import Recaptcha from "../../components/recaptcha";

const Register = (props) => {
  let history = useHistory();
  const [loadingData, setLoadingData] = useState(true);
  const [findUser, setfindUser] = useState(null);
  const [leadSource, setLeadSource] = useState(null);
  const [isNone, setIsNone] = useState(false);
  const [exist, setExist] = useState(false);
  const [showPasword, setShowPasword] = useState(false);
  const [password, setPassword] = useState("");
  const [showEmailClear, setShowEmailClear] = useState(false);
  const [showConfirmPasword, setShowConfirmPasword] = useState(false);
  const [showUserNameClear, setShowUserNameClear] = useState(false);
  const [showLastNameClear, setShowLastNameClear] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [recaptchaMsg, setRecaptchaMsg] = useState("");
  const [products, setProducts] = useState([]);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const currentURL = new URL(window.location.href);
  const queryParameters = new URLSearchParams(window.location.search);
  const course_id = queryParameters?.get("course_id");
  const courseName = queryParameters?.get("course_name");
  const emailNotDecoding = queryParameters?.get("email");
  const email = decodeURIComponent(queryParameters?.get("email"))?.replace(
    / /g,
    "+"
  );
  const handleCaptchaChange = (value) => {
    setIsCaptchaVerified(true);
  };
  // Check if the URL contains the string '?lead_source=' after '/register'
  useEffect(() => {
    if (
      currentURL.pathname === "/register" &&
      currentURL.searchParams.has("lead_source")
    ) {
      const leadSourceValue = currentURL.searchParams.get("lead_source");
      if (leadSourceValue) {
        setLeadSource(leadSourceValue);
      } else {
        console.log("yes, lead_source is present but has no value");
      }
    }
  }, []);

  const registerColl = async (values) => {
    let newData = {};
    setLoadingData(false);
    if (values.email_update) {
      await Repository.postRequest(`api/marketing_emails/create`, {
        email: values.email,
      });
    }
    values.user_name = values.user_name + " " + values?.last_name;
    values.role = values.role.value;
    delete values.confirmPassword;
    delete values.checkboxAgree;

    if (course_id != undefined) {
      newData = {
        ...values,
        phone_number: null,
        lead_source: leadSource,
        invateParams: emailNotDecoding
          ? `course_id=${course_id}&email=${email}&course_name=${encodeURIComponent(
              courseName
            )}`
          : `course_id=${course_id}&course_name=${encodeURIComponent(
              courseName
            )}`,
      };
    } else {
      newData = {
        ...values,
        phone_number: null,
        lead_source: leadSource,
      };
    }

    const result = await Repository.postRequest(`api/users/register`, newData);
    setLoadingData(true);
    if (result.data?.success === true) {
      localStorage.clear();
      if (course_id != undefined) {
        history.push({
          pathname: "/verifyEmail",
          state: { detail: result.data.data },
          search: emailNotDecoding
            ? `course_id=${course_id}&email=${email}&course_name=${courseName}`
            : `course_id=${course_id}&course_name=${courseName}`,
        });
      } else {
        history.push({
          pathname: "/verifyEmail",
          state: { detail: result.data.data },
        });
      }
    } else {
      setIsNone(true);
    }
  };

  const emailSearch = async (values) => {
    const result = await Repository.findByEndPoint(
      `api/users/findUserByEmail/${values}`
    );
    if (result.data?.data) {
      setfindUser(result.data.message);
    } else {
      setfindUser("");
    }
  };

  return loadingData ? (
    <div>
      <HeaderLogo />
      <div className="sectionParentDiv">
        <div className="registerContent ">
          <div>
            <div className="rounded mx-auto d-block registrField">
              <h1>Sign Up</h1>
              <p>Please fill your details to access Smart Study</p>
              <div
                className={
                  isNone ? " errorMessageLogin " : "errorMessageLoginNone"
                }
              >
                <h3>You have a registration error, please try again</h3>
              </div>
              <Formik
                initialValues={{
                  user_name: "",
                  last_name: "",
                  email: "",
                  phone_number: "",
                  password: "",
                  confirmPassword: "",
                  role: {
                    value: "student",
                    label: "Student",
                  },
                  checkboxAgree: false,
                  email_update: true,
                }}
                validate={(values) => {
                  const errors = {};
                  // setExist(false);
                  const specialSymbols =
                    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
                  const letters = /[a-zA-Z]/;

                  setRecaptchaMsg("");

                  if (values.password) {
                    setPassword(values.password);
                  }

                  if (values.user_name) {
                    setShowUserNameClear(true);
                  }
                  if (values.last_name) {
                    setShowLastNameClear(true);
                  }

                  if (values.email) {
                    setShowEmailClear(true);
                  }

                  if (values.confirmPassword) {
                    setConfirmPassword(values.confirmPassword);
                  }
                  if (!values.email) {
                    errors.email = "Email is required.";
                  } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                      values.email
                    )
                  ) {
                    errors.email = "Invalid email address";
                  } else {
                    emailSearch(values.email);
                  }

                  if (findUser == "SMART_STUDY.SUCCESS") {
                    errors.email =
                      "This email is already in use or invalid, please enter another email address";
                  }
                  if (!values.user_name) {
                    setShowUserNameClear(false);

                    errors.user_name = "First name is required.";
                  }

                  if (!values.last_name) {
                    setShowLastNameClear(false);
                  }

                  if (!values.checkboxAgree) {
                    errors.checkboxAgree = "Please agree to continue.";
                  }

                  if (!values.email) {
                    setShowEmailClear(false);
                    errors.email = "Email Address is required.";
                  }

                  if (!values.password) {
                    setPassword(values.password);
                    errors.password = "Password is required.";
                  } else if (values.password.length < 6) {
                    errors.password = "Password must consist of 6 members";
                  } else if (
                    !specialSymbols.test(values.password) ||
                    !letters.test(values.password)
                  ) {
                    errors.password =
                      "Password doesn’t meet the require, password should be minimum 6 characters, 1 special symbol, 1 letter.";
                  }

                  if (!values.confirmPassword) {
                    setConfirmPassword(values.confirmPassword);
                    errors.confirmPassword = "Confirm password is required.";
                  }
                  if (values.confirmPassword != values.password) {
                    errors.confirmPassword = "Passwords must match";
                  }

                  // if (phoneValue == "") {
                  //     errors.phone_number =
                  //         "Phone number is required.";
                  // }

                  return errors;
                }}
                onSubmit={(values) => {
                  if (isCaptchaVerified) {
                    registerColl(values);
                  } else {
                    setRecaptchaMsg(
                      "Please verify reCAPTCHA before submitting."
                    );
                  }
                }}
              >
                {({ formik, setFieldValue }) => (
                  <Form className="formikRegister">
                    <div className="labelInputs">First Name</div>
                    <Field
                      className="formikInput"
                      type="text"
                      name="user_name"
                      placeholder="First Name"
                    />

                    <div className="viewIcon">
                      {showUserNameClear ? (
                        <img
                          onClick={() => {
                            // Clear the "user_name" field value
                            setFieldValue("user_name", "");
                          }}
                          src={clear}
                          alt="clear"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <ErrorMessage
                      className="errorMessage"
                      name="user_name"
                      component="div"
                    />
                    <div className="labelInputs">Last Name</div>
                    <Field
                      className="formikInput"
                      type="text"
                      name="last_name"
                      placeholder="Last Name"
                    />

                    <div className="viewIcon">
                      {showLastNameClear ? (
                        <img
                          onClick={() => {
                            setFieldValue("last_name", "");
                          }}
                          src={clear}
                          alt="clear"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="labelInputs">Email</div>

                    <Field
                      className="formikInput"
                      type="email"
                      name="email"
                      placeholder="Email Address"
                    />
                    <div className="viewIcon">
                      {showEmailClear ? (
                        <img
                          onClick={() => {
                            setFieldValue("email", "");
                          }}
                          src={clear}
                          alt="clear"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <ErrorMessage
                      className="errorMessage"
                      name="email"
                      component="div"
                    />
                    <div className="labelInputs">Password</div>
                    <Field
                      className="formikInput"
                      type={showPasword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      autoComplete="off"
                    />
                    <div className={password ? "viewIcon" : "viewIconNone"}>
                      <img
                        onClick={() => {
                          if (showPasword) {
                            setShowPasword(false);
                          } else {
                            setShowPasword(true);
                          }
                        }}
                        src={showPasword ? view : hidenIcon}
                        alt="view"
                      />
                    </div>
                    <ErrorMessage
                      className="errorMessage"
                      name="password"
                      component="div"
                    />

                    <div className="labelInputs">Confirm Password</div>
                    <Field
                      className="formikInput"
                      type={showConfirmPasword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      autoComplete="off"
                    />
                    <div
                      className={confirmPassword ? "viewIcon" : "viewIconNone"}
                    >
                      <img
                        onClick={() => {
                          if (showConfirmPasword) {
                            setShowConfirmPasword(false);
                          } else {
                            setShowConfirmPasword(true);
                          }
                        }}
                        src={showConfirmPasword ? view : hidenIcon}
                        alt="view"
                      />
                    </div>
                    <ErrorMessage
                      className="errorMessage"
                      name="confirmPassword"
                      component="div"
                    />
                    {/* <div className="labelInputs">
                                            Phone Number
                                        </div>
                                        <PhoneInput
                                            international
                                            placeholder="Enter phone number"
                                            value={phoneValue}
                                            onChange={setPhoneValuee}
                                        />
                                        <ErrorMessage
                                            className="errorMessage "
                                            name="phone_number"
                                            component="div"
                                        /> */}
                    {/* <div
                                            className={
                                                errorPhoneNumber == null
                                                    ? "d-none"
                                                    : "errorMessage"
                                            }
                                        >
                                            {errorPhoneNumber}
                                        </div> */}
                    <div className="labelInputs">
                      Are Your a Instructor or Student?
                    </div>

                    <Field
                      className="mt-2"
                      as={Select}
                      name="role"
                      options={[
                        {
                          value: "instructor",
                          label: "Instructor",
                        },
                        {
                          value: "student",
                          label: "Student",
                        },
                      ]}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          height: 50,
                        }),
                      }}
                      isSearchable={false}
                      onChange={(selectedOption) => {
                        setFieldValue("role", selectedOption);
                      }}
                    />

                    <div className="checkboxDiv d-flex">
                      <Field
                        className="formikChackbox"
                        type="checkbox"
                        name="checkboxAgree"
                      />
                      <span>I agree to the Terms of Service</span>
                    </div>
                    <ErrorMessage
                      className="errorMessage mt-2"
                      name="checkboxAgree"
                      component="div"
                    />
                    <div className="checkboxDiv d-flex">
                      <Field
                        className="formikChackbox"
                        type="checkbox"
                        name="email_update"
                      />
                      <span>I want email updates from Smart Study</span>
                    </div>

                    <div className="mt-3"></div>
                    <Recaptcha onChange={handleCaptchaChange} />
                    <div className="errorMessage mt-2">{recaptchaMsg}</div>
                    <div className="regSubmit">
                      <button type="submit">Sign Up</button>
                    </div>
                  </Form>
                )}
              </Formik>

              {/* <div className="d-flex justify-content-center mt-3">
                                <div id="signInDiv"></div>
                            </div> */}
              <div className="d-flex justify-content-center mt-3">
                <div className="errorMessage ">
                  {exist ? "User already exists" : ""}
                </div>
              </div>
              <h6>
                Already Use Smart Study?
                <span className="linkLogin">
                  {course_id != undefined ? (
                    <Link
                      to={{
                        pathname: "/login",
                        search: emailNotDecoding
                          ? `course_id=${course_id}&email=${email}&course_name=${courseName}`
                          : `course_id=${course_id}&course_name=${courseName}`,
                      }}
                    >
                      Log In
                    </Link>
                  ) : (
                    <Link to="/login"> Log In </Link>
                  )}
                </span>
              </h6>
            </div>
          </div>
        </div>
        <div className="marketingDivJpg ">
          <img src={marketingJpg} alt="marketingJpg" />
        </div>
      </div>
    </div>
  ) : (
    <Spinner spiner={true} />
  );
};

export default Register;
